import { render, staticRenderFns } from "./marketing01.vue?vue&type=template&id=a7e99d70&scoped=true"
import script from "./marketing01.vue?vue&type=script&lang=js"
export * from "./marketing01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e99d70",
  null
  
)

export default component.exports